<template>
    <div :class="{ show: options, hide: !options }" class="l-mask">
        <div @click="closeTask" class="l-close-display"></div>
        <div :class="{ show: options, hide: !options }" class="l-display">
            <div class="l-section">
                <span class="l-week">战绩点评</span>
                <span class="l-close"><i class="icon-lily icon-lily-guanbi1" @click="closeTask"></i></span>
            </div>

            <div class="l-level-list-section-box">
                <div class="l-level-item-box">
                    <div class="l-level-list-item" v-for="(item, index) in list" @click="hanldeToDetail(item)"
                        :key="index">
                        <img v-if="item.readStatus !== 1"
                            class="item-img" src="./images/open.png" alt="" />
                        <img v-else class="item-img" src="./images/no-open.png" alt="" />
                        <div class="item-title">
                            <p>{{ item.commentName }}</p>
                            <p>{{ item.startTime.slice(0, 10) }}至{{ item.endTime.slice(0, 10) }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="l-footer">
                <div class="l-footer-title">
                    <span>*只展示最近6个月的战绩情况</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TaskModel from './../../../models/task'
const taskModel = new TaskModel()
// import Lupload from "./../l-upload/l-task.vue"
export default {
    name: "l-task",
    props: {
        options: {
            type: Boolean,
        },
        list: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    components: {
    },
    watch: {},
    data() {
        return {};
    },
    mounted() { },
    methods: {
        closeTask() {
            this.$emit("closeTask");
        },
        hanldeToDetail(item) {
            if (item.readStatus === 0) {
                taskModel.postWeekRead({
                    taskId: item.taskId,
                    id: item.id
                })
            }
            sessionStorage.setItem('recordData', JSON.stringify(item))
            this.$router.push({
                name: 'recordDetail'
            })
        }
    },
};
</script>

<style lang="stylus" scoped>
@import "./l-task.styl";
</style>
